import { getTime } from 'date-fns';
import { IAnalysisEntity } from '@Data/qualityControl/Interfaces';
import store from '@Services/redux/Store';
import { IPersistedQcPole, IPersistedQcRun } from './Interfaces';
import { BrowserPersistenceActions } from './Reducer';

export const BrowserPersistenceApi = {
    initialize: (
        folderId: string,
        data: IAnalysisEntity[],
        startDate: string
    ) => {
        const convertedDate = getTime(startDate);

        const newPersistedRun: IPersistedQcRun = {
            folder_id: folderId,
            startTimestamp: convertedDate,
            data: data.map((d) => ({
                entity_version_id: d.entity_version_id,
                qcState: d.qcState,
                reworkReasons: d.reworkReasons,
            })),
            elapsedTime: 0,
            lastUpdatedTimestamp: getTime(Date.now()),
        };

        store.dispatch(
            BrowserPersistenceActions.initializePersistedQcRun(newPersistedRun)
        );
    },
    resume: (folderId: string) => {
        store.dispatch(BrowserPersistenceActions.resumeQcRun(folderId));
    },
    updatePersistedPole: (folderId: string, updatedPole: IPersistedQcPole) => {
        store.dispatch(
            BrowserPersistenceActions.updatePersistedQcPole({
                folderId: folderId,
                updatedPole: updatedPole,
            })
        );
    },
    removePersistedQcRun: (folderId: string) => {
        store.dispatch(
            BrowserPersistenceActions.removePersistedQcRun(folderId)
        );
    },
    setSelectedQcPole: (folderId: string, entityVersionId: string) => {
        store.dispatch(
            BrowserPersistenceActions.setSelectedQcPole({
                folderId,
                entityVersionId,
            })
        );
    },
};
